import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_manufacturing_order_return_to_stock_grid_ComponentContextService } from './FootprintManager.manufacturing_order_return_to_stock_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Manufacturing_licenseplates_by_location_singleComponent } from './Manufacturing.licenseplates_by_location_single.component'
import { Manufacturing_lots_by_material_ids_singleComponent } from './Manufacturing.lots_by_material_ids_single.component'


interface IFootprintManager_manufacturing_order_return_to_stock_gridComponentEntity {
  lineNumber?: number, component?: string, lot?: string, remainingQuantity?: number, componentPackageId?: number, countedQuantity?: number, materialId?: number, lotId?: number, sourceLicensePlate?: number, targetLot?: number}

interface IFootprintManager_manufacturing_order_return_to_stock_gridComponentInParams {
  manufacturing_order_line_id?: number, warehouse_id?: number, location: number, manufacturing_order_id?: number, task_chain_head?: number}

interface IFootprintManager_manufacturing_order_return_to_stock_gridComponentOutParams {
  rows?: { materialId?: number, lot?: number, amountToReturn?: number, licensePlate?: number, packageId?: number, sourceLicensePlate?: number, targetLot?: number }[]}

class FootprintManager_manufacturing_order_return_to_stock_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_manufacturing_order_return_to_stock_gridComponent;
  entity: IFootprintManager_manufacturing_order_return_to_stock_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    new_inventory_quantity_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    license_plate_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    target_lot_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    line_number: null,
    component: null,
    source_license_plate: null,
    lot: null,
    remaining_quantity: null,
    new_inventory_quantity: null,
    license_plate: null,
    target_lot: null,
  }

  get $fields_license_plate_selector_inParams_location_id(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $grid.inParams.location;
    
    return expr;
  }
  cacheValueFor_$fields_target_lot_selector_inParams_material_ids: number[];
  get $fields_target_lot_selector_inParams_material_ids(): number[] {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = [$row.entity.materialId];
    
    if(!isEqual(this.cacheValueFor_$fields_target_lot_selector_inParams_material_ids, expr)) {
      this.cacheValueFor_$fields_target_lot_selector_inParams_material_ids = expr;
    }
    return this.cacheValueFor_$fields_target_lot_selector_inParams_material_ids;
  }


  constructor(
    grid: FootprintManager_manufacturing_order_return_to_stock_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_manufacturing_order_return_to_stock_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.line_number = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.line_number,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.component = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.component,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.source_license_plate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.source_license_plate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.lot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.lot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.remaining_quantity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.remaining_quantity,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.new_inventory_quantity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.new_inventory_quantity,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['new_inventory_quantity_edit'] as DatexFormControl, null, false, false, '', '', null)
      );
    
    this.cells.license_plate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.license_plate,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['license_plate_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.target_lot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.target_lot,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['target_lot_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    
    this.formGroup
      .controls['new_inventory_quantity_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.counted_quantity_changed();
      });
  }

  async $initializeExisting(entity: IFootprintManager_manufacturing_order_return_to_stock_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.lineNumber].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_manufacturing_order_return_to_stock_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.lineNumber].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.lineNumber;
    const inParams = {
      $keys:[$resultKey],
    };
    const data = await this.$datasources.Manufacturing.ds_manufacturing_order_return_to_stock_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_manufacturing_order_return_to_stock_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;

  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_new_row_saving();
      this.isNew = false;
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  counted_quantity_changed(event = null) {
    return this.counted_quantity_changedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async counted_quantity_changedInternal(
    $row: FootprintManager_manufacturing_order_return_to_stock_gridComponentRowModel,
  $grid: FootprintManager_manufacturing_order_return_to_stock_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_return_to_stock_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_return_to_stock_grid.counted_quantity_changed');
  
  if(!$utils.isDefined($row.entity.remainingQuantity) || !$utils.isDefined($row.cells.new_inventory_quantity.editControl.value))
  {
      $row.cells.new_inventory_quantity.displayControl.text = "";
      $row.cells.license_plate.displayControl.text = '';
      $row.cells.target_lot.displayControl.text = '';
      $row.cells.license_plate.editControl.value = null;
      $row.cells.target_lot.editControl.value = null;
      $row.cells.license_plate.editControl.readOnly = true;
      $row.cells.target_lot.editControl.readOnly = true;
      return;
  }
  
  if( $row.cells.new_inventory_quantity.editControl.value == 0 )
  {
      $row.cells.license_plate.displayControl.text = '';
      $row.cells.target_lot.displayControl.text = '';
      $row.cells.license_plate.editControl.value = null;
      $row.cells.target_lot.editControl.value = null;
      $row.cells.license_plate.editControl.readOnly = true;
      $row.cells.target_lot.editControl.readOnly = true;
  }
  else
  {
      $row.cells.license_plate.editControl.readOnly = false;
      $row.cells.target_lot.editControl.readOnly = false;
  }
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_manufacturing_order_return_to_stock_gridComponentRowModel,
  $grid: FootprintManager_manufacturing_order_return_to_stock_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_return_to_stock_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_return_to_stock_grid.on_row_data_loaded');
  
  }
  on_new_row_saving(event = null) {
    return this.on_new_row_savingInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_new_row_savingInternal(
    $row: FootprintManager_manufacturing_order_return_to_stock_gridComponentRowModel,
  $grid: FootprintManager_manufacturing_order_return_to_stock_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_return_to_stock_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_return_to_stock_grid.on_new_row_saving');
  if( $row.cells.new_inventory_quantity.editControl.value > 0 && !$utils.isDefined($row.cells.license_plate.editControl.value) )
  {
      $shell.Utilities.openErrorDialog("Select license plate", "Target license plate must be selected for components with quantity for returning.");
      throw new Error();
  }
  
  if( $row.cells.new_inventory_quantity.editControl.value > 0 && !$utils.isDefined($row.cells.target_lot.editControl.value) )
  {
      $shell.Utilities.openErrorDialog("Select lot", "Target lot must be selected for components with quantity for returning.");
      throw new Error();
  }
  
  const lot = await $datasources.Manufacturing.ds_get_lots_by_materialIds.get({materialIds:[$row.entity.materialId], lot_id: $row.entity.lotId});
  
  if( $utils.isDefined(lot.result) )
  {
      $row.cells.lot.displayControl.text = lot.result[0].LookupCode;
  }
  
  $row.cells.new_inventory_quantity.displayControl.text = $row.cells.new_inventory_quantity.editControl.value;
  
  if( $row.cells.new_inventory_quantity.editControl.value > 0 )
  {
      const licensePlate = await $datasources.Manufacturing.ds_get_licenseplates_by_locationId.get({locationId: $grid.inParams.location, license_plate_ids: [$row.cells.license_plate.editControl.value]});
  
      if( $utils.isDefined(licensePlate.result) )
      {
          $row.cells.license_plate.displayControl.text = licensePlate.result[0].LookupCode;
      }
  
      const targetLot = await $datasources.Manufacturing.ds_get_lots_by_materialIds.get({materialIds:[$row.entity.materialId], lot_id: $row.cells.target_lot.editControl.value});
  
      if( $utils.isDefined(targetLot.result) )
      {
          $row.cells.target_lot.displayControl.text = targetLot.result[0].LookupCode;
      }
  }
  
  if( !$utils.isDefined($grid.vars.rows_confirmed) )
      $grid.vars.rows_confirmed = 0;
  
  $grid.vars.rows_confirmed++;
  
  if( $grid.vars.rows_confirmed < $grid.rows.length )
      return;
  
  $grid.outParams.rows = [];
  
  $grid.rows.forEach( item => {
      const row = {materialId: item.entity.materialId,
                   lot: item.entity.lotId,
                   amountToReturn: $utils.isDefined(item.cells.new_inventory_quantity.editControl.value) && item.cells.new_inventory_quantity.editControl.value > 0 ? item.cells.new_inventory_quantity.editControl.value : 0,
                   licensePlate: item.cells.license_plate.editControl.value,
                   targetLot: item.cells.target_lot.editControl.value,
                   packageId: item.entity.componentPackageId,
                   sourceLicensePlate: item.entity.sourceLicensePlate,};
  
      $grid.outParams.rows.push(row);
  })
  
  $grid.events.outParamsChange.emit();
  }
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: FootprintManager_manufacturing_order_return_to_stock_gridComponentRowModel,
  $grid: FootprintManager_manufacturing_order_return_to_stock_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_return_to_stock_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_return_to_stock_grid.on_save_existing_row');
  if( $row.cells.new_inventory_quantity.editControl.value > 0 && !$utils.isDefined($row.cells.license_plate.editControl.value ) )
  {
      $shell.Utilities.openErrorDialog("Select license plate", "License plate must be selected for components with quantity for returning.");
      throw new Error();
  }
  
  const lot = await $datasources.Manufacturing.ds_get_lots_by_materialIds.get({materialIds:[$row.entity.materialId], lot_id: $row.entity.lotId});
  
  if( $utils.isDefined(lot.result) )
  {
      $row.cells.lot.displayControl.text = lot.result[0].LookupCode;
  }
  
  $row.cells.new_inventory_quantity.displayControl.text = $row.cells.new_inventory_quantity.editControl.value;
  
  if( $row.cells.new_inventory_quantity.editControl.value > 0 )
  {
      const licensePlate = await $datasources.Manufacturing.ds_get_licenseplates_by_locationId.get({locationId: $grid.inParams.location, license_plate_ids: [$row.cells.license_plate.editControl.value]});
  
      if( $utils.isDefined(licensePlate.result) )
      {
          $row.cells.license_plate.displayControl.text = licensePlate.result[0].LookupCode;
      }
      
      const targetLot = await $datasources.Manufacturing.ds_get_lots_by_materialIds.get({materialIds:[$row.entity.materialId], lot_id: $row.cells.target_lot.editControl.value});
      
      if( $utils.isDefined(targetLot.result) )
      {
          $row.cells.target_lot.displayControl.text = targetLot.result[0].LookupCode;
      }
  }
  
  if( $grid.vars.rows_confirmed < $grid.rows.length )
      return;
      
  $grid.outParams.rows = [];
  
  $grid.rows.forEach( item => {
      const row = {materialId: item.entity.materialId,
                   lot: item.entity.lotId,
                   amountToReturn: $utils.isDefined($row.cells.new_inventory_quantity.editControl.value) && $row.cells.new_inventory_quantity.editControl.value > 0 ? $row.cells.new_inventory_quantity.editControl.value : 0,
                   licensePlate: item.cells.license_plate.editControl.value,
                   targetLot: item.cells.target_lot.editControl.value,
                   packageId: item.entity.componentPackageId,
                   sourceLicensePlate: item.entity.sourceLicensePlate};
  
      $grid.outParams.rows.push(row);
  })
  
  $grid.events.outParamsChange.emit();
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Manufacturing_licenseplates_by_location_singleComponent),
    forwardRef(() => Manufacturing_lots_by_material_ids_singleComponent),
  ],
  selector: 'FootprintManager-manufacturing_order_return_to_stock_grid',
  templateUrl: './FootprintManager.manufacturing_order_return_to_stock_grid.component.html'
})
export class FootprintManager_manufacturing_order_return_to_stock_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_manufacturing_order_return_to_stock_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);


  inParams: IFootprintManager_manufacturing_order_return_to_stock_gridComponentInParams = { manufacturing_order_line_id: null, warehouse_id: null, location: null, manufacturing_order_id: null, task_chain_head: null };

  outParams: IFootprintManager_manufacturing_order_return_to_stock_gridComponentOutParams = { rows: [] };

  //#region Variables
  vars: { rows_confirmed?: number } = { };
  //#endregion
  //#region Events
  @Output()
  outParamsChange = new EventEmitter<{ rows?: { materialId?: number, lot?: number, amountToReturn?: number, licensePlate?: number, packageId?: number, sourceLicensePlate?: number, targetLot?: number }[] }>();
  
  events = {
    outParamsChange: { emit: () => { this.outParamsChange.emit(this.outParams); } }
  }
  //#endregion

  headers = {
     line_number: new GridHeaderModel(new HeaderStyles(null, null), 'line_number', '#', false, false, null, false),       component: new GridHeaderModel(new HeaderStyles(null, null), 'component', 'Component', false, false, null, false),       source_license_plate: new GridHeaderModel(new HeaderStyles(null, null), 'source_license_plate', 'Source license plate', false, false, null, false),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'lot', 'Source lot', false, false, null, false),       remaining_quantity: new GridHeaderModel(new HeaderStyles(null, null), 'remaining_quantity', 'Remaining quantity', false, false, null, false),       new_inventory_quantity: new GridHeaderModel(new HeaderStyles(null, null), 'new_inventory_quantity', 'Quantity to return', true, false, null, false),       license_plate: new GridHeaderModel(new HeaderStyles(null, null), 'license_plate', 'Target license plate', false, false, null, false),       target_lot: new GridHeaderModel(new HeaderStyles(null, null), 'target_lot', 'Target lot', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_manufacturing_order_return_to_stock_gridComponentRowModel[] = [];

  @Input('manufacturing_order_line_id') set $inParams_manufacturing_order_line_id(value: any) {
    this.inParams['manufacturing_order_line_id'] = value;
  }
  get $inParams_manufacturing_order_line_id(): any {
    return this.inParams['manufacturing_order_line_id'] ;
  }
  @Input('warehouse_id') set $inParams_warehouse_id(value: any) {
    this.inParams['warehouse_id'] = value;
  }
  get $inParams_warehouse_id(): any {
    return this.inParams['warehouse_id'] ;
  }
  @Input('location') set $inParams_location(value: any) {
    this.inParams['location'] = value;
  }
  get $inParams_location(): any {
    return this.inParams['location'] ;
  }
  @Input('manufacturing_order_id') set $inParams_manufacturing_order_id(value: any) {
    this.inParams['manufacturing_order_id'] = value;
  }
  get $inParams_manufacturing_order_id(): any {
    return this.inParams['manufacturing_order_id'] ;
  }
  @Input('task_chain_head') set $inParams_task_chain_head(value: any) {
    this.inParams['task_chain_head'] = value;
  }
  get $inParams_task_chain_head(): any {
    return this.inParams['task_chain_head'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_manufacturing_order_return_to_stock_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Components';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.location)) {
        this.$missingRequiredInParams.push('location');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
    };
    try {
      const data = await this.$datasources.Manufacturing.ds_manufacturing_order_return_to_stock_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_manufacturing_order_return_to_stock_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_manufacturing_order_return_to_stock_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  async addRow(entity?: IFootprintManager_manufacturing_order_return_to_stock_gridComponentEntity) {
    const row = new FootprintManager_manufacturing_order_return_to_stock_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_grid_data_loaded(event = null) {
    return this.on_grid_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadedInternal(
    $grid: FootprintManager_manufacturing_order_return_to_stock_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_return_to_stock_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_return_to_stock_grid.on_grid_data_loaded');
  
  $grid.bottomToolbar.addLine.hidden = true;
  
  const confirmedProductionRows = await $datasources.Manufacturing.ds_get_manufacturing_order_production_confirmation_data.get({manufacturing_order_id: $grid.inParams.manufacturing_order_id
                                                                                                                              , manufacturing_order_line_id: $grid.inParams.manufacturing_order_line_id
                                                                                                                              , operation_code: 47
                                                                                                                              , task_chain_head: $grid.inParams.task_chain_head});
  
  let index = 0;
  
  for (const confirmedComponent of confirmedProductionRows.result) {
  
      const componentInventory = await $datasources.Manufacturing.ds_physical_inventory_by_license_plate_lot.get({license_plate_id: confirmedComponent.ActualSourceLicensePlateId,
                                                                                                                 warehouse_id: confirmedComponent.WarehouseId,
                                                                                                                 material_id: confirmedComponent.MaterialId,
                                                                                                                 lot_id: confirmedComponent.LotId,
                                                                                                                 package_id: confirmedComponent.ActualPackagedPackId,
                                                                                                                 location_id: confirmedComponent.ActualSourceLocationId});
  
      let remainingQuantity = componentInventory.result[0]?.PackagedAmount;
  
      const returnToStockTask = await $datasources.Manufacturing.ds_get_return_to_stock_active_tasks.get({material_id: confirmedComponent.MaterialId,
                                                                                                          license_plate: confirmedComponent.ActualSourceLicensePlateId,
                                                                                                          packaging: confirmedComponent.ActualPackagedPackId,
                                                                                                          warehouse_id: confirmedComponent.WarehouseId,
                                                                                                          location: confirmedComponent.ActualSourceLocationId});
  
      const returnToStockTasksAmount = returnToStockTask.result.reduce((sum, item) => sum + item.ActualPackagedAmount, 0);
  
      if( !$utils.isDefined(remainingQuantity) || ( returnToStockTasksAmount >= remainingQuantity ) )
          continue;
  
      remainingQuantity = remainingQuantity - returnToStockTasksAmount;
  
      const newRow = await $grid.addRow();
  
      index++;
  
      newRow.cells.component.displayControl.text = confirmedComponent.Material?.Name;
      newRow.cells.line_number.displayControl.text = index.toString();
      newRow.cells.source_license_plate.displayControl.text = confirmedComponent.ActualSourceLicensePlate?.LookupCode;
  
      if( remainingQuantity > 0 )
      {
          newRow.cells.license_plate.editControl.readOnly = false;
          newRow.cells.target_lot.editControl.readOnly = false;
      }
  
      newRow.entity.remainingQuantity = remainingQuantity;
      newRow.entity.materialId = confirmedComponent.MaterialId;
      newRow.entity.componentPackageId = confirmedComponent.ActualPackagedPackId;
      newRow.entity.lotId = confirmedComponent.LotId ?? 0;
      newRow.entity.sourceLicensePlate = confirmedComponent.ActualSourceLicensePlateId;
  
      const lot = await $datasources.Manufacturing.ds_get_lots_by_materialIds.get({materialIds: [confirmedComponent.MaterialId], lot_id: confirmedComponent.LotId ?? 0});
  
      if($utils.isDefined(lot.result))
      {
          newRow.cells.lot.displayControl.text = lot.result[0].LookupCode;
      }
  
      newRow.cells.remaining_quantity.displayControl.text = `${remainingQuantity} ${confirmedComponent.ActualPackagedPack?.Name}`;
  
      newRow.cells.new_inventory_quantity.editControl.value = remainingQuantity;
      newRow.cells.new_inventory_quantity.editControl.focus();
  }
  
  $grid.totalCount = index;
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
